function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  id: "Wallet",
  className: "cls-1",
  d: "M12.6,3.287A2.787,2.787,0,0,0,9.813.5H2.787A2.787,2.787,0,0,0,0,3.287V11.62A1.9,1.9,0,0,0,1.909,13.5H12.727A1.263,1.263,0,0,0,14,12.246V4.681A1.5,1.5,0,0,0,12.6,3.287Zm-11.2,0V3.06A1.166,1.166,0,0,1,2.567,1.894h7.466A1.166,1.166,0,0,1,11.2,3.06v.227Zm8.675,6.4A1.382,1.382,0,1,1,11.463,8.3,1.386,1.386,0,0,1,10.075,9.685Z"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "BeBold",
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/wallet.b673b2d1.svg";
export { SvgComponent as ReactComponent };